export const LOADED = 'REQUEST_PARAM_LOADED';



// WEBPACK FOOTER //
// ./src/constants/RequestParam.tsx